import type { CookieCircuitBreakerConfig } from '@atlassian/jira-route-types/src/JiraSpaRoute.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import killswitch from '@atlassian/jira-killswitch';

export function getIssueCircuitBreaker(): CookieCircuitBreakerConfig {
	return {
		isSetCookieEnabled: true,
		isMonitoringEnabled: true,
		isBailoutEnabled: !killswitch('issue-view-cookie-cb'),
		cookieKey: 'iss',
		windowSize: expVal('jfp-magma-ssr-cookie-cb-optimisation', 'windowSize', 5),
		threshold: expVal('jfp-magma-ssr-cookie-cb-optimisation', 'threshold', 0.3),
		keepOpenCount: expVal('jfp-magma-ssr-cookie-cb-optimisation', 'keepOpenCount', 50),
		halfOpenForCount: expVal('jfp-magma-ssr-cookie-cb-optimisation', 'halfOpenForCount', 5),
	};
}
